export default function PainPoint() {
  const painPoints = [
    {
      text: "어디에서 컨설팅을 받아야할지 모르겠어요",
      position: "left"
    },
    {
      text: "큰 돈 내고 맡겼는데 내용이 별로면 어떡하죠?",
      position: "right"
    },
    {
      text: "업체마다 가격이 너무 상이해서 뭐가 맞는 건지 모르겠어요",
      position: "left"
    },
    {
      text: "매번 견적 받고 기다리기가 힘듭니다.",
      position: "right"
    }
  ];

  const solutions = [
    {
      icon: 'ri-shield-check-line',
      title: '고용노동부 인증 기관',
      description: '정식 인증받은 전문 기관으로 신뢰할 수 있는 컨설팅을 제공합니다'
    },
    {
      icon: 'ri-team-line',
      title: '15년 경력 전문가',
      description: '풍부한 경험과 노하우로 실질적인 해결책을 제시합니다'
    },
    {
      icon: 'ri-time-line',
      title: '당일 견적 발송 서비스',
      description: '빠른 견적 발송으로 신속한 업무 진행이 가능합니다'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '감독 대응 증빙자료 관리',
      description: '사후관리까지 책임지고 완벽하게 지원해드립니다'
    }
  ];

  return (
    <section className="py-12 md:py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-slate-900 mb-4 md:mb-6 px-4">
            불투명한 견적, 수많은 컨설팅 업체들의 광고에 질리셨다면?
          </h2>
        </div>

        {/* Pain Points - Chat Style */}
        {/* 모바일 버전 */}
        <div className="md:hidden space-y-4 mb-12">
          {painPoints.map((point, index) => (
            <div 
              key={index}
              className={`flex ${point.position === 'right' ? 'justify-end' : 'justify-start'}`}
            >
              <div className={`relative max-w-[85%] px-5 py-4 rounded-2xl shadow-md ${
                point.position === 'right' 
                  ? 'bg-blue-50 border-2 border-blue-400 rounded-br-sm' 
                  : 'bg-white border-2 border-blue-400 rounded-bl-sm'
              }`}>
                <p className="text-slate-900 text-sm leading-relaxed font-medium">
                  {point.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* PC 버전 */}
        <div className="hidden md:block relative mx-auto mb-6 mt-8 md:mt-12 px-4 md:px-0" style={{ width: '100%', maxWidth: '80%', minHeight: '400px' }}>
          {/* 부드러운 회색 그라데이션 배경 - 가로 타원형 */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[900px] h-[400px] bg-slate-200/50 rounded-full blur-2xl"></div>

          {/* 첫 번째 말풍선 */}
          <div className="absolute" style={{ left: '0', top: '0', width: '100%' }}>
            <div className="w-[65%] relative px-10 py-8 rounded-3xl border-2 shadow-md bg-white border-blue-400">
              <p className="text-slate-900 text-xl leading-relaxed font-medium text-center">
                {painPoints[0].text}
              </p>
              {/* 뾰족한 꼬리 */}
              <div className="absolute" style={{ left: '60px', bottom: '-20px', width: '0', height: '0', borderLeft: '20px solid transparent', borderRight: '20px solid transparent', borderTop: '20px solid #60a5fa' }}></div>
              <div className="absolute" style={{ left: '62px', bottom: '-17px', width: '0', height: '0', borderLeft: '18px solid transparent', borderRight: '18px solid transparent', borderTop: '18px solid white' }}></div>
            </div>
          </div>

          {/* 두 번째 말풍선 */}
          <div className="absolute" style={{ right: '0', top: '80px', width: '100%' }}>
            <div className="w-[65%] ml-auto relative px-10 py-8 rounded-3xl border-2 shadow-md bg-blue-50 border-blue-400">
              <p className="text-slate-900 text-xl leading-relaxed font-medium text-center">
                {painPoints[1].text}
              </p>
              {/* 뾰족한 꼬리 */}
              <div className="absolute" style={{ right: '60px', bottom: '-20px', width: '0', height: '0', borderLeft: '20px solid transparent', borderRight: '20px solid transparent', borderTop: '20px solid #60a5fa' }}></div>
              <div className="absolute" style={{ right: '62px', bottom: '-17px', width: '0', height: '0', borderLeft: '18px solid transparent', borderRight: '18px solid transparent', borderTop: '18px solid #dbeafe' }}></div>
            </div>
          </div>

          {/* 세 번째 말풍선 */}
          <div className="absolute" style={{ left: '0', top: '170px', width: '100%' }}>
            <div className="w-[65%] relative px-10 py-8 rounded-3xl border-2 shadow-md bg-white border-blue-400">
              <p className="text-slate-900 text-xl leading-relaxed font-medium text-center">
                {painPoints[2].text}
              </p>
              {/* 뾰족한 꼬리 */}
              <div className="absolute" style={{ left: '60px', bottom: '-20px', width: '0', height: '0', borderLeft: '20px solid transparent', borderRight: '20px solid transparent', borderTop: '20px solid #60a5fa' }}></div>
              <div className="absolute" style={{ left: '62px', bottom: '-17px', width: '0', height: '0', borderLeft: '18px solid transparent', borderRight: '18px solid transparent', borderTop: '18px solid white' }}></div>
            </div>
          </div>

          {/* 네 번째 말풍선 */}
          <div className="absolute" style={{ right: '0', top: '260px', width: '100%' }}>
            <div className="w-[65%] ml-auto relative px-10 py-8 rounded-3xl border-2 shadow-md bg-blue-50 border-blue-400">
              <p className="text-slate-900 text-xl leading-relaxed font-medium text-center">
                {painPoints[3].text}
              </p>
              {/* 뾰족한 꼬리 */}
              <div className="absolute" style={{ right: '60px', bottom: '-20px', width: '0', height: '0', borderLeft: '20px solid transparent', borderRight: '20px solid transparent', borderTop: '20px solid #60a5fa' }}></div>
              <div className="absolute" style={{ right: '62px', bottom: '-17px', width: '0', height: '0', borderLeft: '18px solid transparent', borderRight: '18px solid transparent', borderTop: '18px solid #dbeafe' }}></div>
            </div>
          </div>
        </div>

        {/* Solution Section - Enhanced Design */}
        <div className="relative bg-gradient-to-br from-cyan-50 via-blue-50 to-sky-50 rounded-3xl p-6 md:p-12 shadow-xl border border-blue-100 mt-8 md:mt-28">
          {/* Decorative Elements */}
          <div className="absolute top-0 left-1/4 w-32 h-32 bg-blue-200/30 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-1/4 w-40 h-40 bg-cyan-200/30 rounded-full blur-3xl"></div>
          
          <div className="relative z-10">
            <div className="text-center mb-8 md:mb-12">
              <div className="inline-block mb-3 md:mb-4">
                <i className="ri-check-double-line text-4xl md:text-6xl bg-gradient-to-br from-blue-500 to-cyan-500 bg-clip-text text-transparent"></i>
              </div>
              <h3 className="text-2xl md:text-4xl lg:text-5xl font-extrabold bg-gradient-to-r from-blue-600 via-cyan-600 to-blue-600 bg-clip-text text-transparent mb-2 md:mb-3">
                저희가 해결 해드리겠습니다!
              </h3>
              <p className="text-base md:text-lg text-slate-600 font-medium">
                믿을 수 있는 컨설팅 전문기관, 중대안전보건예방협회입니다
              </p>
            </div>

            {/* Solutions Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-6xl mx-auto">
              {solutions.map((solution, index) => (
                <div 
                  key={index} 
                  className="group bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-transparent hover:border-cyan-400 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl relative overflow-hidden"
                >
                  {/* Hover Background Effect */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-cyan-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  
                  <div className="relative z-10">
                    <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl mb-4 md:mb-5 mx-auto shadow-md group-hover:scale-110 transition-transform duration-300">
                      <i className={`${solution.icon} text-2xl md:text-3xl text-white`}></i>
                    </div>
                    <h4 className="text-base md:text-lg font-bold text-slate-900 mb-2 md:mb-3 text-center group-hover:text-blue-600 transition-colors duration-300">
                      {solution.title}
                    </h4>
                    <p className="text-xs md:text-sm text-slate-600 text-center leading-relaxed">
                      {solution.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
